<template>
  <div class="carousel_wrap">
    <!-- PC端：Element UI轮播 隐藏移动端 -->
    <el-carousel
        height="35vw"
        loop
        arrow="hover"
        class="hidden-xs-only"
    >
      <el-carousel-item
          v-for="(item, index) in imgList"
          :key="index"
          @click.native="handleArticleInfo(item.url)"
      >
        <img :src="item.src" alt="首页轮播图" class="img_item"/>
      </el-carousel-item>
    </el-carousel>

    <!-- 移动端：Vant2 van-swipe 隐藏PC端 | 核心：设置高度+开启循环+补全点击 -->
    <van-swipe
        :autoplay="3000"
        loop
        height="45vw"
        class="hidden-sm-and-up"
    >
      <van-swipe-item
          v-for="(item, index) in imgList"
          :key="index"
          @click="handleArticleInfo(item.url)"
      >
      <img :src="item.src" alt="首页轮播图" class="img_item" />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { getImgList } from "@/api/home";
import { ImageTypeEnum } from "@/enums/imageTypeEnum";
// 按需引入Vant2的swipe（如果项目未全局引入，需加这行）
import { Swipe, SwipeItem } from 'vant';
import 'vant/lib/swipe/style';
import 'vant/lib/swipe-item/style';

export default {
  components: { // 注册Vant2组件（全局引入则可省略）
    VanSwipe: Swipe,
    VanSwipeItem: SwipeItem
  },
  data() {
    return {
      imgList: [] // banner图数组
    }
  },
  created() {
    this.getBannerList();
  },
  methods: {
    // 获取banner图列表：补充catch异常处理，避免接口报错卡死
    getBannerList() {
      getImgList(ImageTypeEnum.HOME_BANNER.value)
          .then(res => {
            this.imgList = res.data || []; // 容错：防止返回null/undefined
          })
          .catch(err => {
            console.error('banner图获取失败：', err);
            this.imgList = [];
          });
    },
    // 点击跳转：增强容错，判断路由格式
    handleArticleInfo(url) {
      if (url && typeof url === 'string' && url.trim()) {
        this.$router.push(url.trim());
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// 外层容器：占满宽度，相对定位
.carousel_wrap {
  position: relative;
  width: 100%;
  margin: 0;
  padding: 0;
  ::v-deep .van-swipe__indicator {
    display: none !important;
  }
  // 穿透修改Element UI轮播样式（PC端）
  ::v-deep .el-carousel,
  ::v-deep .el-carousel__item {
    width: 100%;
    height: 100% !important; // 填满外层容器
  }

  // 穿透修改Vant2轮播样式（移动端）
  ::v-deep .van-swipe,
  ::v-deep .van-swipe-item {
    width: 100%;
    height: 100% !important; // 填满外层容器，保证图片容器无留白
  }

  // 统一PC/移动端图片样式：核心保证完整显示
  .img_item {
    width: 100%;
    height: 100%;
    display: block; // 去掉图片默认间隙
    object-fit: contain; // 关键：图片完整显示，不裁剪、不拉伸（留等比空白）
    object-position: center; // 图片居中对齐，避免偏移
    cursor: pointer; // 鼠标手型，移动端自动识别
  }
}
</style>